import { configureStore, createAction } from "@reduxjs/toolkit";

import rootReducer from "./rootReducer";
import { removeError } from "./reducers/errorSlice";
import { errorTypes } from "../utils/constant";
// Define the action to reset the state
const resetState = createAction("resetState");

const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});

const rootReducerWithReset = (state: any, action: any) => {
    if (action.type === resetState.type) {
        state = undefined;
    }
    return rootReducer(state, action);
};

store.replaceReducer(rootReducerWithReset);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export { resetState };

let currentValue = 0;

export const unsubscribePayloadChangeHandler = store.subscribe(() => { removeError({ type: errorTypes.PAYLOAD_ERROR }) });

export default store;
